export default __webpack_public_path__ + "static/website_automate-7c61f1d8a8619ba497e2a9fa926fb843.png";